module.exports = __webpack_public_path__ + "img/wechat.1df73df6.svg";